import { has } from 'lodash';
import { IBaseWidget } from '../widgets/IBaseWidget';
import { IWidgetDirectiveType } from './IWidgetDirectiveType';

export interface IConfiguredDirective {
  directive: IWidgetDirectiveType<any>;
  directiveConfig?: any;
}

class WidgetDirectivesRepositoryClass {
  public types: Record<string, IWidgetDirectiveType<any>> = {};

  /**
   * Registra una nuova direttiva di widget
   * @param directiveType
   */
  register<T extends Record<string, any>>(
    directiveType: IWidgetDirectiveType<T>,
  ) {
    if (has(this.types, directiveType.key)) {
      const error = new Error(
        `Impossibile registrare una Direttiva di Widget con chiave: "${directiveType.key}" poiché è già registrata`,
      );
      if (process.env.NODE_ENV === 'development') {
        console.warn(error.message);
        return;
      }

      throw error;
    }

    this.types[directiveType.key] = directiveType;
  }

  getAll() {
    return Object.values(this.types);
  }

  /**
   * Ottiene tutte le direttive _configurate_ in un widget (a meno che non siano forzate ad essere applicate sempre)
   */
  getConfiguredInWidget(widget: IBaseWidget): IConfiguredDirective[] {
    const directives: IConfiguredDirective[] = [];

    for (const directiveKey of Object.keys(this.types)) {
      const directive = this.types[directiveKey];

      if (!directive) {
        console.warn(
          `Impossibile trovare la direttiva di widget con chiave "${directiveKey}"`,
        );
        continue;
      }

      if (!widget.directives?.[directiveKey] && !directive.isAlwaysApplied)
        continue;

      directives.push({
        directive,
        directiveConfig: widget.directives?.[directiveKey],
      });
    }

    return directives;
  }
}

export const WidgetDirectivesRepository = new WidgetDirectivesRepositoryClass();
